// extracted by mini-css-extract-plugin
export default {"appChatIcon":"Chatbot_appChatIcon__KYsZJ","appChatIconHidden":"Chatbot_appChatIconHidden__bNT-k"};